module.exports = __webpack_public_path__ + "img/SignHereWatermark.95b41492.png";